import { Trans } from '@lingui/macro'
import {
  Topbar,
  TopbarLeft,
  TopbarRight,
  TopbarTitle
} from 'front-end/src/components/common/topbar/Topbar'
import React from 'react'
import { navigateTo } from '../../../app/util/appHistory'
import { staticLinks } from '../../../../../shared/linkBuilder'
import { ButtonOutline } from '../../../components'
import { IconGridManage } from '../../../components/common/icon/IconGridManage'
import { AdminOnlyAllowed } from 'front-end/src/components/common/AdminOnlyAllowed'

export const StudentPathwayTopbar = () => (
  <Topbar>
    <TopbarLeft>
      <TopbarTitle>
        <Trans>Pathways</Trans>
      </TopbarTitle>
    </TopbarLeft>
    <TopbarRight display={['none', 'flex']}>
      <AdminOnlyAllowed allowManagerAccess>
        <ButtonOutline
          onClick={() => navigateTo(staticLinks.managePathways)}
          px="12px"
          leftIcon={<IconGridManage boxSize="18px" />}
        >
          <Trans>Manage pathways</Trans>
        </ButtonOutline>
      </AdminOnlyAllowed>
    </TopbarRight>
  </Topbar>
)
